<template>
	<div>
		<p style="height: 80px;line-height: 80px; text-indent: 40px;">机构首页设置申请</p>

		<el-row style="padding-left: 60px;">
			<!-- <el-col :span="6">
				<div style="display: flex;align-items: center">
					<span style="margin-right: 5px">机构名称</span>
					<el-tooltip class="item" effect="dark" :content="state1" placement="top" :disabled="!state1">
						<el-autocomplete class="inline-input inp" v-model="state1" :fetch-suggestions="querySearch1"
							placeholder="请选择机构、院校" @select="handleSelect1" @blur="blur" style="min-width: 250px"
							clearable></el-autocomplete>
					</el-tooltip>
				</div>
			</el-col> -->
			<el-col :span="6">
				<div style="display: flex;align-items: center">
					<span style="margin-right: 5px;width: 100px;">申请人</span>
					<el-input placeholder="请输入申请人/手机号" v-model="username" clearable>
					</el-input>
					<div style="margin-left: 20px">
						<el-button type="success" @click="getserce()">查找</el-button>
					</div>
				</div>
			</el-col>
			<el-col style="margin-top: 20px;">
				<div style="display: flex;align-items: center">
					<span style="margin-right: 5px;width: 100px;">申请状态</span>
					<el-radio-group v-model="radio" @input="inputradio">
						<el-radio label="">全部</el-radio>
						<el-radio :label="0">待审核</el-radio>
						<el-radio :label="1">审核通过</el-radio>
						<el-radio :label="2">审核不通过</el-radio>
					</el-radio-group>
				</div>

			</el-col>
		</el-row>
		<el-row style="margin-top: 20px;">
			<el-col>
				<el-table :data="tableData" border style="width: 92%; margin: 0 auto;">
					<el-table-column prop="key" label="序号">
					</el-table-column>
					<el-table-column prop="account_name" label="申请人">
					</el-table-column>
					<el-table-column prop="phone" label="手机号">
					</el-table-column>
					<el-table-column prop="first_organization" label="机构名称/一级院校">
					</el-table-column>
					<el-table-column prop="second_organization" label="二级院校">
					</el-table-column>
					<el-table-column prop="create_time" label="申请时间">
					</el-table-column>
					<el-table-column prop="create_time" label="当前设置">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="seeres(scope.row, false)">查看</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="create_time" label="申请状态">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="seeres(scope.row, true)">{{ scope.row.apply_state ==
								0 ? '待审核' : (scope.row.apply_state == 1 ? '审核成功' :
									'未通过审核')
							}}</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="create_time" label="操作">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="shanchu(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row class="displaycontent">
			<el-pagination background layout="prev, pager, next" :total="total" :page-size="pagesize"
				:current-page="currentpage" @current-change="currentchange">
			</el-pagination>

		</el-row>
		<el-dialog title="首页设置申请" :visible.sync="dialogVisible" width="30%">
			<el-row style="padding-left: 90px;margin-top: 40px;">
				<el-col :span="11">
					<div v-for="(item, index) in onelist">
						<div class="box" v-if="index == 0">
							<p>{{ item.menu_id == 1 ? '知识教学' : '名校名师' }}</p>
							<div>
								<el-switch v-model:checked="item.isshow" disabled />
							</div>
						</div>
					</div>

				</el-col>
				<el-col :span="2">
					<div style="width: 30px;">
						<img src="https://resource.rgzcloud.com/trainfile/pc_webreception%202.0/images/zhihuanhei.svg"
							alt="" style="width: 100%;">
					</div>
				</el-col>
				<el-col :span="11">
					<div class="displaybetween" v-for="(item, index) in onelist">
						<div></div>
						<div class="box" v-if="index == 1">
							<p>{{ item.menu_id == 2 ? '名校名师' : '知识教学' }}</p>
							<div>
								<el-switch v-model:checked="item.isshow" disabled />
							</div>
						</div>
					</div>
				</el-col>
				<el-col :span="11">
					<div v-for="(item, index) in towlist">
						<div class="box" v-if="index == 0">
							<p>{{ item.menu_id == 3 ? '校园公开课' : '校内公开课' }}</p>
							<div>
								<el-switch v-model:checked="item.isshow" disabled />
							</div>
						</div>
					</div>


				</el-col>
				<el-col :span="2">
					<div style="width: 30px;">
						<img src="https://resource.rgzcloud.com/trainfile/pc_webreception%202.0/images/zhihuanhei.svg"
							alt="" style="width: 100%;">
					</div>
				</el-col>
				<el-col :span="11">
					<div class="displaybetween" v-for="(item, index) in towlist">
						<div></div>
						<div class="box" v-if="index == 1">
							<p>{{ item.menu_id == 4 ? '校内公开课' : '校园公开课' }}</p>
							<div>
								<el-switch v-model:checked="item.isshow" disabled />
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row class="displaybetween" v-if="isshenhe">
				<el-button type="primary" @click="shenghe(1)">审核通过</el-button>
				<el-button type="primary" @click="shenghe(2)">审核不通过</el-button>
			</el-row>
		</el-dialog>
	</div>
</template>

<script>
import { Remotesearch } from "../../../assets/js/network/network.js";
export default {
	name: "index",
	components: {},
	data() {
		return {
			state1: '',
			organization_id: '',
			restaurants1: [],
			username: '',
			radio: '',
			tableData: [],
			total: 0,
			pagesize: 15,
			currentpage: 1,
			dialogVisible: false,
			onelist: [{
				name: '知识教学',
				key: 'Knowledge',
				value: false
			}, {
				name: '名校名师',
				key: 'Famous',
				value: true
			}],
			towlist: [{
				name: '校园公开课',
				value: true
			}, {
				name: '校内公开课',
				value: false
			}],
			isshenhe: false,
			currentitem: null

		};
	},
	methods: {
		seeres(item, isshenheitem) {
			let data = {
				id: item.id
			}
			this.$get(this.$api.organization_menu_setting, data).then(res => {

				if (res.code == 0) {
					this.currentitem = item;
					res.ret.first_nav.forEach(element => {
						element.isshow = element.isshow == 0 ? false : true
					});
					res.ret.second_nav.forEach(element => {
						element.isshow = element.isshow == 0 ? false : true
					});
					this.onelist = res.ret.first_nav;
					this.towlist = res.ret.second_nav;
					this.dialogVisible = true;
					this.isshenhe = isshenheitem;
				}
			})


		},
		shanchu(item) {
			this.$confirm('是否删除此申请记录', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {

				let data = {
					id: item.id
				}
				this.$post(this.$api.organization_menu_del, data).then(res => {

					if (res.code == 0) {

						this.getlist();
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
					}

				})



			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		shenghe(state) {
			let data = {
				apply_state: state,
				id: this.currentitem.id
			}
			this.$post(this.$api.organization_menu_audit, data).then(res => {
				if (res.code == 0) {

					this.dialogVisible = false;
					this.getlist();
					this.$message({
						message: '审核成功',
						type: 'success'
					});
				}


			})
		},
		handleSelect1(item) {
			// console.log(item);
			this.organization_id = item.id;
			this.currentpage = 1;
			this.getlist()
		},
		currentchange(val) {
			this.currentpage = val;
			this.getlist()
		},
		getserce() {
			this.currentpage = 1;
			this.getlist()
		},
		inputradio() {
			this.currentpage = 1;
			this.getlist()
		},
		getlist() {
			let data = {
				organization_id: JSON.parse(localStorage.getItem('session')).organization_id,
				// organization_id:'',
				account: this.username,
				apply_state: this.radio,
				currentPage: this.currentpage
			}
			this.$get(this.$api.organization_menu_list, data).then(res => {
				res.ret.data.forEach((item, index) => {
					item.key = (res.ret.current_page - 1) * res.ret.per_page + parseInt(index) + 1;
				});
				this.tableData = res.ret.data;
				this.total = res.ret.total;
				this.pagesize = res.ret.per_page;
				this.currentpage = res.ret.current_page;
			})
		}
	},
	mounted() {


		this.getlist()

	}
};
</script>
<style scoped>
@import "../../../style/common.css";

.displaycontent {
	display: flex !important;
	justify-content: center !important;
	items-align: center !important;

}

.displaybetween {
	justify-content: space-between;
	display: flex;
}

.box {
	display: flex;
	margin-bottom: 20px;
}

.box p {
	margin-bottom: 0;
	width: 100px;

}
</style>
